import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import { ConfigProvider } from "@/context/ConfigContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Counselling from "@/pages/Counselling";
import Consulting from "@/pages/Consulting";
import Services from "@/pages/Services";
import Approach from "@/pages/Approach";
import Library from "@/pages/Library";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Portal from "@/pages/Portal";
import Intake from "@/pages/Intake";
import Groups from "@/pages/Groups";
import Media from "@/pages/Media";
import AdminWaitlist from "@/pages/AdminWaitlist";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  return (
    <LangProvider>
    <ConfigProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="counselling" element={<Counselling />} />
            <Route path="consulting" element={<Consulting />} />
            <Route path="services" element={<Counselling />} />
            <Route path="approach" element={<Approach />} />
            <Route path="library" element={<Library />} />
            <Route path="blog/*" element={<Navigate to="/" replace />} />
            <Route path="contact" element={<Contact />} />
            <Route path="book" element={<Booking />} />
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="portal" element={<Portal />} />
            <Route path="intake" element={<Intake />} />
            <Route path="groups" element={<Groups />} />
            <Route path="media" element={<Media />} />
            <Route path="admin/waitlist" element={<AdminWaitlist />} />
            <Route path="payment/success" element={<PaymentSuccess />} />
            <Route path="payment/cancel" element={<PaymentCancel />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ConfigProvider>
    </LangProvider>
  );
}

export default App;
